import script from "./editThemeAssignment.vue?vue&type=script&setup=true&lang=js"
export * from "./editThemeAssignment.vue?vue&type=script&setup=true&lang=js"

import "./editThemeAssignment.vue?vue&type=style&index=0&id=71293378&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71293378"]])

export default __exports__